import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { addFormData, checkUsernameExists } from "../firebase";
import PortfolioPage from "../pages/PortfolioPage";
import formStyles from "../styles/formStyles";
import PropTypes from "prop-types";

const JoyousForm = ({ closeModal = () => {} }) => {
  useEffect(() => {
    console.log("✅ JoyousForm component mounted.");
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    bio: "",
    username: "",
    password: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { username } = formData;

    const usernameExists = await checkUsernameExists(username);
    if (usernameExists) {
      alert("Username already taken! Please choose another.");
      return;
    }

    try {
      await addFormData(formData, "joyousApplications", username);
      setFormData({
        name: "",
        email: "",
        phone: "",
        bio: "",
        username: "",
        password: ""
      });

      // Removed success message or modal close
      // closeModal?.();

      const isVanillaHTML = document.getElementById("index-content");

      if (isVanillaHTML) {
        console.log("🧠 Detected index.html vanilla environment");

        // Hide the static content
        document.getElementById("index-content").style.display = "none";

        // Show the full React root
        const fullRoot = document.getElementById("full-react-root");
        fullRoot.style.display = "block";

        // Mount the React PortfolioPage
        const root = createRoot(fullRoot);
        root.render(
          <BrowserRouter>
            <Routes>
              <Route path="/portfolio/:username" element={<PortfolioPage />} />
              <Route
                path="*"
                element={<Navigate to={`/portfolio/${username}`} replace />}
              />
            </Routes>
          </BrowserRouter>
        );
      } else {
        console.warn("⚠️ SPA navigation may be unreliable — forcing full reload");

        // Force a reload to ensure fresh page and route
        const targetUrl = `/portfolio/${username}`;
        console.log("🔄 Forcing full reload to:", targetUrl);
        window.location.replace(targetUrl);
      }
    } catch (error) {
      console.error("🚨 Error submitting form:", error);
      alert("Oops! Something went wrong. Please try again.");
    }
  };

  return (
    <form onSubmit={handleSubmit} style={formStyles.formContainer}>
      <h2 style={formStyles.heading}>Showcase. Stand Out. Be Seen.</h2>

      <label style={formStyles.label}>
        Full Name:
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          style={formStyles.inputField}
          required
        />
      </label>

      <label style={formStyles.label}>
        Email Address:
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          style={formStyles.inputField}
          required
        />
      </label>

      <label style={formStyles.label}>
        Contact Number:
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          style={formStyles.inputField}
        />
      </label>

      <label style={formStyles.label}>
        About You:
        <textarea
          name="bio"
          value={formData.bio}
          onChange={handleChange}
          style={formStyles.textareaField}
          required
        />
      </label>

      <label style={formStyles.label}>
        Username:
        <input
          type="text"
          name="username"
          value={formData.username}
          onChange={handleChange}
          style={formStyles.inputField}
          required
        />
      </label>

      <label style={formStyles.label}>
        Password:
        <input
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          style={formStyles.inputField}
          required
        />
      </label>

      <button type="submit" style={formStyles.submitButton}>
        Launch Portfolio
      </button>
    </form>
  );
};

JoyousForm.propTypes = {
  closeModal: PropTypes.func
};

export default JoyousForm;
